import React, { useState, useEffect } from 'react';
import './PrioritySnapshotsManager.css';
import { 
  hasInitialState,
  getInitialStateInfo,
  restoreInitialState
} from '../utils/snapshotManager';

/**
 * Uproszczony komponent przywracający stan początkowy produktów
 */
function PrioritySnapshotsManager({ onRestoreSnapshot }) {
  const [initialStateInfo, setInitialStateInfo] = useState(null);
  const [restoreInProgress, setRestoreInProgress] = useState(false);
  const [message, setMessage] = useState(null);
  
  // Sprawdzamy czy istnieje zapisany stan początkowy
  useEffect(() => {
    if (hasInitialState()) {
      const info = getInitialStateInfo();
      console.log('Znaleziono początkowy stan produktów:', info);
      setInitialStateInfo(info);
    } else {
      console.log('Nie znaleziono zapisanego stanu początkowego');
    }
  }, []);
  
  // Automatyczne ukrywanie komunikatów po określonym czasie
  useEffect(() => {
    if (message && message.timeout) {
      const timer = setTimeout(() => {
        setMessage(null);
      }, message.timeout);
      
      return () => clearTimeout(timer);
    }
  }, [message]);
  
  /**
   * Obsługuje przywrócenie początkowego stanu
   */
  const handleRestoreInitialState = () => {
    console.log('DEBUG: Rozpoczęcie procesu przywracania stanu początkowego...');
    console.log('DEBUG: onRestoreSnapshot istnieje?', !!onRestoreSnapshot);
    console.log('DEBUG: Typ onRestoreSnapshot:', typeof onRestoreSnapshot);
    
    if (window.confirm('Czy na pewno chcesz przywrócić oryginalny stan produktów z pliku XML?')) {
      try {
        console.log('DEBUG: Użytkownik potwierdził przywrócenie stanu początkowego');
        setRestoreInProgress(true);
        setMessage({
          type: 'info',
          text: 'Przywracanie oryginalnego stanu...',
          timeout: 0 // Bez automatycznego ukrywania
        });
        
        console.log('DEBUG: Wywołuję funkcję restoreInitialState z modułu snapshotManager');
        
        // Przywracamy początkowy stan
        const result = restoreInitialState((restoredProducts) => {
          console.log(`DEBUG: restoreInitialState zwróciła ${restoredProducts.length} produktów`);
          console.log('DEBUG: Przykładowy produkt:', JSON.stringify(restoredProducts[0], null, 2).substring(0, 200) + '...');
          
          // Przekazujemy przywrócone produkty do funkcji callback
          if (onRestoreSnapshot && typeof onRestoreSnapshot === 'function') {
            console.log('DEBUG: Przekazuję przywrócone produkty do funkcji callback w App.js');
            try {
              onRestoreSnapshot(restoredProducts);
              console.log('DEBUG: Callback w App.js zakończył działanie');
            } catch (callbackError) {
              console.error('DEBUG: Błąd podczas aktualizacji stanu aplikacji:', callbackError);
              setMessage({
                type: 'error',
                text: `Błąd: ${callbackError.message}`,
                timeout: 5000
              });
            }
          } else {
            console.error('DEBUG: Brak funkcji callback lub nieprawidłowy format!');
            console.log('DEBUG: onRestoreSnapshot:', onRestoreSnapshot);
          }
        });
        
        console.log('DEBUG: Wynik operacji restoreInitialState:', result);
        
        // Wyświetlamy wynik operacji
        setMessage({
          type: result.success ? 'success' : 'error',
          text: result.message,
          timeout: 3000
        });
      } catch (error) {
        console.error('DEBUG: Błąd podczas przywracania stanu początkowego:', error);
        setMessage({
          type: 'error',
          text: `Błąd: ${error.message}`,
          timeout: 5000
        });
      } finally {
        setRestoreInProgress(false);
      }
    } else {
      console.log('DEBUG: Użytkownik anulował przywrócenie stanu początkowego');
    }
  };
  
  /**
   * Renderuje komunikat
   */
  const renderMessage = () => {
    if (!message) return null;
    
    return (
      <div className={`message ${message.type}`}>
        {message.text}
      </div>
    );
  };
  
  // Jeśli nie ma zapisanego stanu początkowego, pokazujemy informację
  if (!initialStateInfo) {
    return (
      <div className="priority-snapshots-manager">
        <p>Brak zapisanego stanu początkowego. Zostanie on utworzony automatycznie przy wczytaniu pliku XML.</p>
      </div>
    );
  }
  
  return (
    <div className="priority-snapshots-manager">
      {renderMessage()}
      
      <div className="initial-state-info">
        <p>
          <strong>Plik:</strong> {initialStateInfo.fileName}<br />
          <strong>Data wczytania:</strong> {initialStateInfo.timestamp}<br />
          <strong>Produktów:</strong> {initialStateInfo.productsCount}
        </p>
      </div>
      
      <div className="restore-button-container">
        <button
          className="restore-initial-button"
          onClick={handleRestoreInitialState}
          disabled={restoreInProgress}
          title="Przywróć oryginalny stan produktów z pliku XML"
        >
          {restoreInProgress ? 'Przywracanie...' : 'Przywróć oryginalną kolejność'}
        </button>
      </div>
    </div>
  );
}

export default PrioritySnapshotsManager; 